/*
 * Reform — Shipping Protection cart toggle.
 * Delegated + idempotent: one document-level listener handles every re-render of
 * the toggle (the drawer morphs its markup on each cart change, so per-node
 * listeners would be lost). Adds/removes the protection variant via the AJAX cart
 * API, then dispatches the theme's `shopify:cart:lines-update` event so the cart
 * drawer refreshes and the toggle re-renders from the live cart (Liquid decides
 * on/off state), keeping quantity at 1 and preventing duplicates.
 */
(function () {
  if (window.__reformShipInit) return;
  window.__reformShipInit = true;

  var CART_ADD = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
  var CART_CHANGE = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js';
  var CART_GET = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js';

  function refreshTheme() {
    // Tell the theme's cart components to refetch + morph the cart sections.
    var evt = new Event('shopify:cart:lines-update', { bubbles: true });
    evt.promise = Promise.resolve({ detail: {} });
    document.dispatchEvent(evt);
    // Keep the branded nav pill in sync.
    fetch(CART_GET, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-reform-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-reform-ship-toggle');
    if (!btn) return;
    e.preventDefault();

    var row = btn.closest('.js-reform-ship');
    if (!row || row.classList.contains('is-busy')) return;

    var variantId = row.getAttribute('data-variant-id');
    var lineKey = row.getAttribute('data-line-key');
    var inCart = row.getAttribute('data-in-cart') === 'true';
    if (!variantId) return;

    row.classList.add('is-busy');

    var req;
    if (inCart) {
      // Remove: setting quantity 0 by line key (or variant id) clears it entirely.
      req = fetch(CART_CHANGE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey || variantId, quantity: 0 })
      });
    } else {
      // Add exactly one. Never increments an existing line.
      req = fetch(CART_ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
    }

    req
      .then(function (r) { return r.json(); })
      .then(function () { refreshTheme(); })
      .catch(function () {})
      .then(function () { row.classList.remove('is-busy'); });
  });
})();
